<template>
  <section class="n3-banda" v-if="CTA?.Mostrar && CTA.Titulo?.Texto" :style="fondo ? { '--n3-banda-img': `url(${fondo})` } : undefined">
    <div class="n2-contenedor n3-banda__contenido n2-aparece">
      <h2>{{ CTA.Titulo.Texto }}</h2>
      <p v-if="CTA.Subtitulo?.Texto">{{ CTA.Subtitulo.Texto }}</p>
      <template v-if="CTA.Button?.Texto">
        <a v-if="externo" :href="CTA.Button.Url" target="_blank" rel="noopener" class="n2-boton n2-boton--acento n2-boton--grande">{{ CTA.Button.Texto }}</a>
        <NuxtLink v-else :to="CTA.Button.Url || getLocalePath('/contacto')" class="n2-boton n2-boton--acento n2-boton--grande">{{ CTA.Button.Texto }}</NuxtLink>
      </template>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
const store = useStore()
const { NOTARIA } = storeToRefs(store)
const { imagenIDtoSRC, getFile, getLocalePath } = useUtils()
// Panel: Inicio → Llamada a la acción. De fondo, la imagen del banner (si es una foto)
const CTA = computed(() => NOTARIA.value?.Theme?.Home?.CallToAction)
const externo = computed(() => /^https?:\/\//i.test(CTA.value?.Button?.Url || ''))
const fondo = computed(() => {
  const id = NOTARIA.value?.Theme?.Home?.Banner?.Imagen
  return id && getFile(id)?.type !== 'video/mp4' ? imagenIDtoSRC(id) : ''
})
</script>
